
import { gql } from "@apollo/client";

export const CancelRent = gql`
  mutation CancelRenting($id: String!) {
    cancelRenting(id: $id)
  }
`;